module.exports = __webpack_public_path__ + "img/travelite.ae0e7b36.jpg";